import ApartmentIcon from "@mui/icons-material/Apartment";
import {
    CircularProgress,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetchCompany } from "@/queries/useFetchCompany.ts";
import type { HistoryItem } from "@/queries/useFetchHistoryForCurrentUser.ts";

type Props = {
    historyItem: HistoryItem;
};

const CompanyHistoryItem = ({ historyItem }: Props) => {
    const [companyUUID, setCompanyUUID] = useState("");
    const navigate = useNavigate();

    const { data, isError, isRefetching, isLoading } = useFetchCompany({
        isQueryEnabled: companyUUID !== "",
        placeId: companyUUID,
    });

    useEffect(() => {
        if (data?.data?.id) {
            navigate(`/company-detail/${data?.data.id}`);
        }
    }, [data?.data]);

    return (
        <ListItem key={historyItem.idUUID} disablePadding>
            <ListItemButton onClick={() => setCompanyUUID(historyItem.idGlobalUUID ?? "")}>
                {historyItem.faicon && (
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                        <ApartmentIcon sx={{ color: "blue" }} />
                    </ListItemIcon>
                )}
                <ListItemText
                    primary={historyItem.name}
                    secondary={`${dayjs(historyItem.metaModifiedWhen).format("MMM D hh:mma")}`}
                />
                {(isLoading || isRefetching) && <CircularProgress size={"12px"} />}
                {isError && <Typography variant={"h5"}>Error loading documents</Typography>}
            </ListItemButton>
        </ListItem>
    );
};

export default CompanyHistoryItem;
